"use client";

import React from "react";
import ListingSaveButton from "./ListingSaveButton";
import { useSavedListingsMap } from "@/components/listing/SavedListingsProvider";
import { UserListingSavedFrom } from "@/db/definitions";

type Props = {
  listingId: string;
  text: {
    ariaLabel: string;
    default?: string | null;
    saved?: string | null;
    toast: {
      added: string;
      removed: string;
      error: string;
    };
  };
  type: UserListingSavedFrom;
};

const ListingSaveButtonWithMap: React.FC<Props> = ({
  listingId,
  text,
  type,
}) => {
  const savedMap = useSavedListingsMap();
  const isSaved = savedMap?.[listingId] ?? false;

  return (
    <ListingSaveButton
      isSaved={isSaved}
      listingId={listingId}
      text={text}
      type={type}
    />
  );
};

export default ListingSaveButtonWithMap;
